import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
var _excluded = ["open", "action", "variant", "onClose", "children", "ContentProps", "hasCloseButton", "TransitionComponent"];
import { Portal, Slide, Snackbar as MaterialSnackbar } from '@material-ui/core';
import { forwardRef } from 'react';
import { SnackbarContent } from "./SnackbarContent.js";
import { jsx as _jsx } from "react/jsx-runtime";
function SlideTransition(props) {
  return /*#__PURE__*/_jsx(Slide, _objectSpread(_objectSpread({}, props), {}, {
    direction: "up"
  }));
}
export var Snackbar = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
      open,
      action,
      variant,
      onClose,
      children,
      ContentProps,
      hasCloseButton = onClose != null,
      TransitionComponent = SlideTransition
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  function handleClose(reason) {
    if (reason !== 'clickaway') {
      onClose === null || onClose === void 0 ? void 0 : onClose(reason === 'timeout' ? 'timeout' : 'explicit');
    }
  }
  return /*#__PURE__*/_jsx(Portal, {
    children: /*#__PURE__*/_jsx(MaterialSnackbar, _objectSpread(_objectSpread({}, props), {}, {
      ref: ref,
      open: open,
      TransitionComponent: TransitionComponent,
      onClose: (_, reason) => {
        handleClose(reason);
      },
      children: /*#__PURE__*/_jsx(SnackbarContent, _objectSpread(_objectSpread({}, ContentProps), {}, {
        action: action,
        variant: variant,
        onClose: !hasCloseButton ? undefined : () => {
          handleClose('explicit');
        },
        children: children
      }))
    }))
  });
});
if (process.env.NODE_ENV !== "production") Snackbar.displayName = "Snackbar";